module.exports = __webpack_public_path__ + "img/fig26.16427f1e.jpg";